import React from "react";
import Body from "components/Body";
import TopRightShape from "components/Shapes/TopRightShape";

export default function ParagraphTemporaryText({ data }) {
  const isHighlighted = data.field_highlighted;
  const now = new Date();
  const startDate = new Date(`${data.field_date_start} 00:00:00`);
  const endDate = new Date(`${data.field_date_end} 23:59:59`);
  
  return (now.getTime() >= startDate.getTime() && now.getTime() < endDate.getTime()) && (
    <div className="w-full mx-auto lg:max-w-screen-lg h-full">
      {isHighlighted ? (
        <ParagraphTextHighlighted data={data} />
      ) : (
        <>
          {data.field_temporary_title && (
            <h2 className="mb-8 font-important text-4xl">{data.field_temporary_title}</h2>
          )}
          <div className="prose max-w-none">
            <Body value={data.field_temporary_text.processed} />
          </div>
        </>
      )}
    </div>
  );
}

function ParagraphTextHighlighted({ data }) {
  return (
    <div className="relative bg-primary p-8 lg:p-16 rounded-md h-full">
      <div className="absolute top-0 right-0" aria-hidden="true">
        <TopRightShape className="w-36 h-auto text-white/30" />
      </div>

      {data.field_temporary_title && (
        <h2 className="mb-8 font-important text-2xl text-white">
          {data.field_temporary_title}
        </h2>
      )}

      <div className="prose prose-white font-important text-lg max-w-none">
        <Body value={data.field_temporary_text.processed} />
      </div>
    </div>
  );
}
